'use client';

// Prevent caching - this page redirects based on user's auth state
export const dynamic = 'force-dynamic';

import Cookies from 'cookies-js';
import { useRouter } from 'next/navigation';
import { useEffect, useMemo } from 'react';
import NoBranchAccess from '@/legacy/components/app/NoBranchAccess';
import useBranches from '@/legacy/data/branch/useBranches';
import useAuth from '@/legacy/hooks/useAuth';
import SnackbarProvider from '@/legacy/state/Snackbar/SnackbarProvider';
import Loader from '@/legacy/styled-components/components/Loader';

const selectedBranchCookieName = 'selectedBranch';

export default function RootPage() {
  const router = useRouter();
  const { initialized, decodedToken } = useAuth();
  const [branches, requestBranches] = useBranches();

  // Check if user has belongs-to-branch claim
  const belongsToBranch = decodedToken?.['belongs-to-branch'];
  const hasBranchClaim = belongsToBranch
    ? typeof belongsToBranch === 'string'
      ? !!belongsToBranch
      : !!belongsToBranch.length
    : false;

  const targetBranchId = useMemo(() => {
    if (!branches?.length) return undefined;

    const fromCookie = Cookies.get(selectedBranchCookieName);
    // Find the branch from cookie, or fall back to first branch
    const preferred = fromCookie
      ? branches.find((x) => x.id === fromCookie) || branches[0]
      : branches[0];

    return preferred?.id;
  }, [branches]);

  useEffect(() => {
    // Only redirect once authenticated and we have a valid branch ID
    if (initialized && targetBranchId) {
      router.replace(`/${targetBranchId}`);
    }
  }, [initialized, targetBranchId, router]);

  // Show NoBranchAccess if user is authenticated but has no branch claim
  if (initialized && !hasBranchClaim && !requestBranches.isLoading) {
    return (
      <SnackbarProvider>
        <NoBranchAccess />
      </SnackbarProvider>
    );
  }

  return <Loader />;
}
